import React from "react";
import Chart7 from "../Charts/Chart7";
import Table1 from "../Tables/Table1";

const SensorFive = (props) => {
    const theme = props.theme;
  return (
    <div>
      <div
        className={`${theme === "dark" ? "bg-slate-950" : "bg-white"}  flex flex-col xl:flex-nowrap flex-wrap  justify-between bg-dark-echarts gap-5 gap-y-5 `}
      >
        <Chart7 theme={props.theme} title="Energy Consumption by Source" />
      </div>
      <div className=" flex gap-5 gap-y-5 my-5 justify-center items-center">
        <Table1 theme={props.theme} />
      </div>
    </div>
  );
};

export default SensorFive;
